import { gql } from '@apollo/client';

export const REMOVE_VEHICLE_ALERT = gql`
  mutation removeVehicleAlert($input: RemoveVehicleAlertInput!) {
    removeVehicleAlert(input: $input) {
      errors
    }
  }
`


